export const renameProperty = (o, oldKey, newKey) => {
  o[newKey] = o[oldKey];
  delete o[oldKey];
};
